export enum MergeInto {
	ContextData = 0,
	RecordData = 1,
}
